import locale from '../locale/default';
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/default.js
// module id = 537
// module chunks = 0